const awsConfig = {
    API: {
      GraphQL: {
        endpoint: 'https://xzrbzpzgnjafndpp6pewiy4dmq.appsync-api.us-east-1.amazonaws.com/graphql',
        region: 'us-east-1',
        defaultAuthMode: 'apiKey',
        apiKey: 'da2-lt5u53umlvatvh4dqlaslbvcfq',
      }
    }
  };
  
  export default awsConfig
  